module.exports = __webpack_public_path__ + "img/Dragon_5_400.cdeb92d7.png";